export default {"src":"/_next/static/media/bikeOutline100_40.7b37d80e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};